export class MissingField {

  constructor(
    public fieldId: string,
    public fieldLabel: string,
    public fieldValue: string = ''
  ) {
  }

  static fromJson(json: any): MissingField {

    return new MissingField(
      json.fieldId,
      json.fieldLabel
    )
  }

  json(): any {

    return {
      fieldId: this.fieldId,
      fieldValue: this.fieldValue
    }
  }
}

export class MissingFieldForm {

  constructor(
    public missingFields: MissingField[],
    public formSubject: string = '',
    public formTemplate: string = '',
    public emailSubject: string = '',
    public emailDate: string = '',
    public created: Date,
    public completed: Date | undefined
  ) {
  }

  public formOlderOneDay(): boolean {

    if(Math.abs(this.created.valueOf() - Date.now()) / 1000 > 86400) {

      return true;

    } else {

      return false;
    }
  }

  json(): any {

    return {
      submittedFields: this.missingFields.map(field => field.json())
    }
  }

  static fromJson(json: any): MissingFieldForm {

    const missingFields: MissingField[] = [];
    json
      .missingFieldsMessageForm
      .missingFields
      .forEach((missingFieldJson: any) => {

        missingFields.push(MissingField.fromJson(missingFieldJson))
      });

    let completed: Date | undefined;

    if (json.missingFieldsMessageForm.completed) {

      completed = new Date(json.missingFieldsMessageForm.completed);
    }

    let missingFieldForm = new MissingFieldForm(
      missingFields,
      json.missingFieldsMessageForm.formSubject,
      json.missingFieldsMessageForm.formTemplate,
      json.missingFieldsMessageForm.emailSubject,
      json.missingFieldsMessageForm.emailDate,
      new Date(json.missingFieldsMessageForm.created),
      completed
    );

    return missingFieldForm;
  }
}
